import OutlineClose from '@/assets/images/outline-close.svg';
import UploadImage from '@/assets/images/tray-arrow-up.svg';
import type { FileData } from '../../types';

interface AdditionalItemsUploadProps {
  data: Record<string, FileData | undefined>;
  fileName: string;
  handleFile: (event: React.ChangeEvent<HTMLInputElement>, type: string) => void;
  removeFile: (fileName: string, type: string) => void;
}

export default function AdditionalItemsUpload({
  data,
  handleFile,
  removeFile,
  fileName,
}: AdditionalItemsUploadProps): React.ReactNode {
  return (
    <div className="document-form__additional-items__dropdowns--input">
      <div className="document-form__additional-input-container">
        {data[fileName] ? (
          <img
            className="document-form__uploaded-image"
            src={data[fileName]?.filePreview}
            alt=""
          />
        ) : null}

        {!data[fileName] ? (
          <>
            <input
              id={fileName}
              className="document-form__input"
              name={fileName}
              type="file"
              onChange={(event) => handleFile(event, 'additionalItemsDocuments')}
            />
            <label
              htmlFor={fileName}
              className="document-form__image-container"
            >
              <img
                className="document-form__input-upload"
                src={UploadImage}
                alt=""
              />
            </label>
          </>
        ) : (
          <div className="document-form__remove-image-container">
            <img
              className="document-form__remove-image"
              onClick={() => removeFile(fileName, 'additionalItemsDocuments')}
              src={OutlineClose}
              alt=""
            />
          </div>
        )}
      </div>
    </div>
  );
}
